import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            height: '40px',
        }
    },
    containerInput: {
        border: `1px solid ${themeCommon.lightBlue}`,
        borderRadius: '10px',
        padding: '15px',
        width: '200px',
        height: '50px',
        marginRight: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            marginRight: '5px',
            width: '140px',
        },
        [theme.breakpoints.down('xs')]: {
            width: '120px',
            height: '40px',
        },
    },
    containerIcon: {
        cursor: 'pointer',
    },
    input: {
        textAlign: 'center',
        padding: '0px',
        fontSize: themeCommon.fontSize18px,
        fontFamily: themeCommon.RobotoRegular,
        [theme.breakpoints.down('sm')]: {
            fontSize: themeCommon.fontSize16px
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: themeCommon.fontSize12px
        },
    }
}), {
    name: 'InputSCHeadContainer',
    index: 1,
})

export default useStyles;